import { useQuery } from '@tanstack/react-query';
import { fetchPublicCatalog } from '@/lib/api';

/** The public shop catalog, cached for the session. One fetch feeds every
 *  category page + product detail (products resolve client-side, same pattern
 *  the driver store uses). */
export function useCatalog(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['shop-catalog'],
    queryFn: fetchPublicCatalog,
    staleTime: 5 * 60_000,
    enabled: options?.enabled ?? true,
  });
}
